import { axiosObject } from '../setup';

function publishAnnualisedPremiaRates() {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_RATES_API_URL}/annualised-premia-rates`;
    axiosObject
      .post(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function publishAnnualisedPremiaRatesStaging() {
  return new Promise((resolve, reject) => {
    let uri = `${process.env.NX_PUBLIC_RATES_STAGING_API_URL}/annualised-premia-rates`;
    axiosObject
      .post(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { publishAnnualisedPremiaRates, publishAnnualisedPremiaRatesStaging };
